<template>
  <div v-if="eves_dij" class="alert alert-dark mb-5">
    <h1 class="h2 text-white">
      AZ ÖN ÁLTAL MEGADOTT ADATOK ALAPJÁN A BIZTOSÍTÁSI DÍJ:
    </h1>
    <div class="row">
      <div class="col-md-8">
        <div class="form-group row mb-2">
          <label class="col-sm-6 fw-bold"></label>
          <div class="col-sm-6">
            <input
              type="text"
              class="form-control"
              disabled
              :value="
                eves_dij
                  | currency({
                    symbol: currencySymbol,
                    symbolPosition: currency === 'huf' ? 'back' : 'front',
                  })
              "
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6"></div>
      <div class="col-sm-12"></div>
    </div>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import {mapActions} from 'vuex';

export default {
  components: {},
  computed: {
    ...mapFields(['currency', 'insuranceYearlyPrice', 'eves_dij']),
    currencySymbol: {
      get() {
        const currencies = {huf: 'Ft', eur: '€', usd: '$'};
        return currencies[this.currency];
      },
    },
  },
};
</script>
